import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { IxcRegistrationV1EmploymentSeasonal } from '@interxfi/types/generated/api';
import { AppTextInputWithLens } from '../../../../../../components/form/app-text-input';

export const seasonalFormSchema = z.object({
  kind: z.literal('seasonal'),
  value: z.object({
    institution: z.string().nonempty({ error: 'Institution is required' }),
    occupation: z.string().nonempty({ error: 'Occupation is required' }),
  }),
});

type SeasonalFormValues = z.infer<typeof seasonalFormSchema>;

export const defaultSeasonalFormValues: SeasonalFormValues = {
  kind: 'seasonal',
  value: {
    institution: '',
    occupation: '',
  },
};

export function getInitialFormValuesForSeasonal(data: IxcRegistrationV1EmploymentSeasonal | undefined): SeasonalFormValues {
  return {
    ...defaultSeasonalFormValues,
    value: {
      institution: data?.institution ?? '',
      occupation: data?.occupation ?? '',
    },
  };
}

export function formValuesToSeasonal(values: SeasonalFormValues): IxcRegistrationV1EmploymentSeasonal {
  return {
    institution: values.value.institution.trim(),
    occupation: values.value.occupation.trim(),
  };
}

interface EmploymentSeasonalFormProps {
  lens: Lens<SeasonalFormValues>;
}

export function EmploymentSeasonalForm({ lens }: EmploymentSeasonalFormProps) {
  return (
    <VerticalStack gap={4}>
      <AppTextInputWithLens label="Occupation" lens={lens.focus('value.occupation')} required />
      <AppTextInputWithLens label="Institution" lens={lens.focus('value.institution')} required />
    </VerticalStack>
  );
}
